import React from "react"
import SbEditable from "storyblok-react"

import Components from "../components/components.js"

import { BlogListing } from "gatsby-theme-gba"

const BlogListingEditable = ({ blok }) => {
  const bloksAfter = !blok.after ? null : (
    <>
      {blok.after &&
        blok.after.map(blokItem =>
          React.createElement(Components(blokItem.component), {
            key: blokItem._uid,
            blok: {
              ...blokItem,
              currentLanguage: blok.currentLanguage,
              seoLinks: blok.seoLinks,
            },
          })
        )}
    </>
  )

  return (
    <SbEditable content={blok}>
      <BlogListing
        slogan={blok.slogan}
        pageTitle={blok.pageTitle || ""}
        numPages={blok.numPages}
        baseLink={blok.baseLink}
        currentPage={blok.currentPage}
        noEntries={!blok.entries || blok.entries.length === 0}
        noEntriesText={blok.noEntriesText}
        headline={blok.headline}
        bloksAfter={bloksAfter}
        first={blok.first}
        last={blok.last}
        prev={blok.prev}
        next={blok.next}
        seoLinks={blok.seoLinks}
      >
        {blok.entries &&
          blok.entries
            .slice(
              (blok.currentPage - 1) * blok.entriesPerPage,
              blok.currentPage * blok.entriesPerPage
            )
            .map((child_blok, index) => {
              let content = child_blok.content
              content.component = "bigBlogTeaser"
              content.link = child_blok.full_slug
              content.date = child_blok.sort_by_date
              content.tagList = child_blok.tag_list
              content.seoLinks = blok.seoLinks
              content.currentLanguage = blok.currentLanguage
              const component = React.createElement(
                Components(content.component),
                {
                  key: index,
                  blok: content,
                }
              )
              return component
            })}
      </BlogListing>
    </SbEditable>
  )
}

export default BlogListingEditable
